import React from 'react';
import classNames from 'classnames';
import FloatingAction from '../floating-action';
import Text from '../text';
import noop from '../utils/noop';
import isNoop from '../utils/is-noop';

const HALF_BUTTON_SIZE = 24;

function AddContentTrigger({
  captions: { title, annotation },
  icon = 'plus',
  onClick = noop,
  centered = false,
  onContextMenu = noop,
}) {
  const classes = classNames('ws-add-content-trigger', {
    'ws-add-content-trigger--centered': centered,
  });

  const contextMenuHandler = (event) => {
    if (isNoop(onContextMenu)) return;
    event.preventDefault();
    const { clientX, clientY } = event;
    onContextMenu(clientX, clientY);
  };

  return (
    <div className="ws-add-content-trigger-wrapper" onContextMenu={contextMenuHandler}>
      <div className={classes}>
        <Text type="heading-5">{title}</Text>
        <div className="ws-add-content-trigger__button">
          <FloatingAction
            // @ts-ignore TS(2322): Type 'string' is not assignable to type 'never'.
            icon={icon}
            // @ts-ignore TS(2322): Type '(...args: any[]) => any' is not assignable t... Remove this comment to see the full error message
            onClick={onClick}
            // @ts-ignore TS(2322): Type 'number' is not assignable to type 'never'.
            offsetX={HALF_BUTTON_SIZE}
            // @ts-ignore TS(2322): Type 'number' is not assignable to type 'never'.
            offsetY={HALF_BUTTON_SIZE}
          />
        </div>
        <Text type="heading-6" theme="grey">
          {annotation}
        </Text>
      </div>
    </div>
  );
}

export default AddContentTrigger;
